import React from 'react'
import { Table } from 'react-bootstrap'

import StatisticsTableRow from './StatisticsTableRow'

const StatisticsTable = (props) => {
    const { sites } = props
    return (
        <Table bordered id="statistics-table">
            <thead>
                <tr>
                    <th className="sticky-col col-one" style={{ zIndex: 9999 }}>
                        Country
                    </th>

                    <th className="sticky-col col-two" style={{ zIndex: 9999 }}>
                        Site
                    </th>

                    <th>
                        Incomplete
                    </th>

                    <th>
                        Approved
                    </th>

                    <th>
                        Pending
                        <br />
                        Investigator
                        <br />
                        Review
                    </th>

                    <th>
                        Requires
                        <br />
                        Revisions
                    </th>

                    <th>
                        Pending
                        <br />
                        Data
                        <br />
                        Manager
                        <br />
                        Review
                    </th>

                    <th>
                        Pending
                        <br />
                        Data
                        <br />
                        Validation
                    </th>

                    <th>
                        Ineligible
                    </th>

                    <th>
                        Adverse
                        <br />
                        Drug
                        <br />
                        Reactions
                    </th>

                    <th>
                        Total
                        <br />
                        Eligible
                        <br />
                        Patients
                    </th>
                </tr>
            </thead>
            <tbody>
                {sites && typeof sites === 'object' && Object.keys(sites).length ?
                    <>
                        {Object.keys(sites).sort((a, b) => {
                            const siteAString = `${sites[a].site_country} ${sites[a].site_number}`
                            const siteBString = `${sites[b].site_country} ${sites[b].site_number}`
                            return siteAString.localeCompare(siteBString)
                        })
                            .map(key => (
                                <StatisticsTableRow
                                    key={key}
                                    site={{ ...sites[key], site_name: key }}
                                />
                            )
                        )}
                    </> :
                    null
                }
            </tbody>
        </Table>
    )
}

export default StatisticsTable
